// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout-module--layout--3AkVA","layout__main":"Layout-module--layout__main--3eIz4","layout__alignBottom":"Layout-module--layout__align-bottom--1jxl1"};